/**
 * SHO-8647 — Mobiele Algolia-search: thema-eigen empty-state + clear-knop.
 *
 * De Algolia-zoekmodal (app-block `hds-algolia-bridge-app`) rendert zijn eigen
 * inhoud. Dit thema-script vult die aan zónder de app-bundle te wijzigen:
 *   1. Een clear-knop (✕) rechts in de zoekbalk (de app-close-knop wordt via
 *      CSS de ←-dismiss linksboven).
 *   2. Een THEMA-EIGEN empty-state panel (uit <template id="…-extras">) met
 *      "Snel naar" (quick-links). Dit staat los van de app-body, dus het werkt
 *      óók als de app z'n resultaten-body niet rendert (bv. dev/preview-theme).
 *      Getoond wanneer het veld leeg is; verborgen zodra er een zoekterm staat.
 *   Populaire zoekopdrachten worden door de Algolia bridge-app gerenderd.
 *   Alleen mobiel (<=749px). Robuust: faalt stil, her-plaatst bij herrender.
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';
  var TEMPLATE_ID = 'hds-search-mobile-extras';
  var MODAL_SELECTOR = '[data-hds-algolia-search-modal]';
  var MODAL_INNER = '.hds-algolia-search--modal';
  var INPUT_SELECTOR = MODAL_INNER + ' .hds-algolia-search__input';
  var FIELD_SELECTOR = MODAL_INNER + ' .hds-algolia-search__field';

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }
  function getHost() {
    return document.querySelector(MODAL_SELECTOR);
  }
  function getInput(host) {
    return host ? host.querySelector(INPUT_SELECTOR) : null;
  }
  function hasQuery(input) {
    return !!(input && input.value && input.value.trim().length);
  }

  // Native value-setter: laat de app reageren ongeacht of de input vanilla of
  // React-controlled is (React negeert een kale input.value = ...).
  var nativeSetter = (function () {
    try {
      return Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    } catch (e) {
      return null;
    }
  })();

  /** Zet de zoekterm in de input en laat de app opnieuw zoeken. */
  function runSearch(input, term) {
    if (!input) return;
    if (nativeSetter) {
      nativeSetter.call(input, term);
    } else {
      input.value = term;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.focus();
  }

  /* ---------------------------------------------------------------- clear */

  function ensureClearButton(host) {
    var field = host.querySelector(FIELD_SELECTOR);
    var input = getInput(host);
    if (!field || !input) return;

    if (!field.querySelector('.hds-search-clear')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hds-search-clear';
      btn.setAttribute('aria-label', 'Zoekopdracht wissen');
      btn.innerHTML =
        '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">' +
        '<path d="M5 5l10 10M15 5L5 15" fill="none" stroke="currentColor" ' +
        'stroke-width="1.6" stroke-linecap="round"/></svg>';
      btn.addEventListener('click', function () {
        runSearch(input, '');
        sync(host);
      });
      field.appendChild(btn);
    }
  }

  /* -------------------------------------------------------- empty-state panel */

  function ensurePanel(host) {
    var modal = host.querySelector(MODAL_INNER);
    if (!modal) return null;
    var panel = modal.querySelector('.hds-search-panel');
    if (panel) return panel;

    var tpl = document.getElementById(TEMPLATE_ID);
    if (!tpl || !tpl.content) return null;
    var src = tpl.content.querySelector('.hds-search-panel');
    if (!src) return null;

    panel = src.cloneNode(true);
    // In de modal zelf plaatsen (altijd zichtbaar). NIET in .__dropdown: die
    // krijgt van de app een `hidden`-attribuut bij leeg veld (display:none).
    modal.appendChild(panel);
    return panel;
  }

  /** Toon/verberg panel + secties op basis van de huidige toestand. */
  function sync(host) {
    var field = host.querySelector(FIELD_SELECTOR);
    var input = getInput(host);
    if (!field || !input) return;

    // clear-knop tonen zodra er tekst staat
    var clear = field.querySelector('.hds-search-clear');
    if (clear) clear.hidden = !hasQuery(input);

    if (!isMobile()) return;
    var panel = ensurePanel(host);
    if (!panel) return;

    // Panel alleen tonen bij leeg veld (anders toont de app resultaten).
    panel.hidden = hasQuery(input);
  }

  /* ------------------------------------------------------------ plumbing */

  var scheduled = false;
  function schedule(host) {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      ensureClearButton(host);
      sync(host);
    });
  }

  function init() {
    var host = getHost();
    if (!host) return;

    // input-events → clear-knop + panel bijwerken
    document.addEventListener('input', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('hds-algolia-search__input')) {
        sync(host);
      }
    });

    new MutationObserver(function () { schedule(host); })
      .observe(host, { childList: true, subtree: true });

    document.addEventListener('hds-algolia-search:open', function () {
      window.setTimeout(function () { schedule(host); }, 0);
    });

    schedule(host);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
